/*
 * @Author: wzh
 * @LastEditTime: 2024-05-23 14:24:17
 * @Description:
 */
import { strictFetch, unstrictFetch } from "./http";

// 登录
export async function login(formInline) {
  return strictFetch({
    url: "/login/signin",
    method: "POST",
    data: formInline,
  });
}

// 退出登录
export async function logout() {
  return strictFetch({
    url: "/authz/cas/logout",
    method: "GET",
  });
}

// 获取用户信息
export async function userInfo() {
  return strictFetch({
    url: "/auth/info",
    method: "POST",
  });
}

/**
 * 如果请求第三方接口使用 unstrictAxios 避免进入拦截器逻辑
 */
export async function outerInfo() {
  return unstrictFetch({
    baseURL: "https://abc.com",
    url: "/xxx",
    method: "GET",
    params: {
      query1: "aaa",
      query2: "bbb",
    },
  });
}
